import styles from "../../foryou/_components/DesctopComponents/Desctop.module.scss";
import {useTranslation} from "react-i18next";
import OverlayRatingIcon from "../../../components/icons/searchIcons/OverlayRatingIcon";
import OverlayTomatoRatingIcon from "../../../components/icons/searchIcons/OverlayTomatoRatingIcon";

interface IProps {
  title: string,
  releaseDate: string,
  genres: any,
  runtime: number,
  voteAverage: number,
  imdbRating?: number | null,
  kinopoiskRating?: number | null,
}

const InfoData = ({
  title,
  releaseDate,
  genres,
  runtime,
  voteAverage,
  imdbRating,
  kinopoiskRating,
}: IProps) => {
  const {t} = useTranslation();
  const primaryRating = imdbRating ? imdbRating.toFixed(1) : voteAverage ? voteAverage.toFixed(1) : "9.1";
  const secondaryRating = kinopoiskRating ? kinopoiskRating.toFixed(1) : primaryRating;

  return (
    <div>
      <div className={styles.rowInfoWrapper}>
        <span>{releaseDate ? releaseDate.split("-")[0] : "2023"}</span>
        <span>USA</span>
        {false && (
          <span className={styles.badge}>Скоро</span>
        )}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.detailsGenres}>
        {genres && (
          <>
            {genres[0] && <span>{t(`${genres[0]?.name}`)}</span>}
            {genres[1] && <span>{t(`${genres[1]?.name}`)}</span>}
          </>
        )}
        <span>{runtime} {t('minutes')}</span>
      </div>
      <div className={styles.detailsRatingsRow}>
        <span className={styles.detailsRating}>
          <OverlayRatingIcon />
          {primaryRating}
        </span>
        <span className={styles.detailsRating}>
          <OverlayTomatoRatingIcon />
          {secondaryRating}
        </span>
      </div>
    </div>
  )
}

export default InfoData;
